import React, { ComponentType, SVGProps } from 'react'
import { Stack, SvgIcon } from '@mui/material'
import { DataTableText } from './DataTableText'

export const DataTableStatus = ({ icon, label }: { icon: ComponentType<SVGProps<SVGSVGElement>>; label: string }) => (
    <Stack direction="row" alignItems="center" gap={1} minWidth={0}>
        <SvgIcon component={icon} inheritViewBox fontSize="small" />
        <DataTableText text={label} />
    </Stack>
)

export default DataTableStatus
